export default function StickyHeader(window, document) {
  const globalAlert = document.querySelector('.global-alert');
  const documentElement = document.documentElement;

  // The amount of downward movement before header is hidden
  const downTolerance = 10;
  let lastScrollTop = 0;

  const updateGlobalAlertHeight = function () {
    if (!globalAlert) {
      documentElement.style.setProperty('--global-alert-height', '0px');
      return 0;
    }

    // Only include alert height if it's visible
    const alertStyle = window.getComputedStyle(globalAlert);
    if (alertStyle.display === 'none' || alertStyle.visibility === 'hidden') {
      documentElement.style.setProperty('--global-alert-height', '0px');
      return 0;
    }

    const height = globalAlert.offsetHeight;
    documentElement.style.setProperty('--global-alert-height', `${height}px`);
    return height;
  };

  const onScroll = function () {
    const pageY = window.scrollY;
    const globalAlertHeight = updateGlobalAlertHeight();

    // Determine scroll direction and set header offset
    if (pageY <= 0) {
      // At top of page
      documentElement.style.setProperty('--header-offset', '0');
    } else if (pageY > lastScrollTop + downTolerance && pageY > globalAlertHeight) {
      documentElement.style.setProperty('--header-offset', '-100%');
    } else if (pageY < lastScrollTop) {
      documentElement.style.setProperty('--header-offset', '0');
    }

    lastScrollTop = pageY;
  };

  updateGlobalAlertHeight();
  onScroll();

  window.addEventListener('scroll', onScroll, { passive: true });

  // Update global alert height on resize (in case alert content changes)
  window.addEventListener('resize', updateGlobalAlertHeight, { passive: true });
}
